module.exports = __webpack_public_path__ + "static/logo-white-af4b5aff002fd6b6d813edaf037f3243.svg";